import { UpperCasePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule, ModalController } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { map, take } from "rxjs/operators";
import { StorePaymentComponent } from "src/app/pages/store/store-payment/store-payment.component";
import { SyndicateTicketsComponent } from "src/app/pages/syndicate/syndicate-tickets/syndicate-tickets.component";
import { PaymentService } from "src/app/services/payment.service";
import { VoucherService } from "src/app/services/vouchers.service";
@Component({
  selector: "app-voucher-redeem",
  templateUrl: "./voucher-redeem.component.html",
  styleUrls: ["./voucher-redeem.component.scss"],
  standalone: true,
  imports: [
    IonicModule,
    UpperCasePipe,
    TranslatePipe,
  ],
})
export class VoucherRedeemComponent implements OnInit {
  voucherSuccessResponse;
  dialogData: any;
  public userId: string;
  constructor(
    private router: Router,
    public translate: TranslateService,
    private authService: AuthService,
    private analytics: AngularFireAnalytics,
    private voucherService: VoucherService,
    private modalController: ModalController,
    private paymentService: PaymentService
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
  }

  async ngOnInit() {
    await this.authService.getUid("VoucherRedeemComponent").then((uid) => {
      this.userId = uid;
    })
    this.analytics.logEvent("voucher_success_modal", { userId: this.userId });

    this.voucherService?.voucher$?.subscribe((res) => {
      this.voucherSuccessResponse = res;
      this.dialogData = res;
    });
  }

  openCompleteProfilePage() {
    // this.dialogRef.close(true);
    if (this.dialogData && (this.dialogData?.button_link || this.dialogData?.paid_button_link)) {
      if (this.dialogData.button_link && this.dialogData.button_link.search("store") > -1) {
        this.openStorePage();
      } else if (
        this.dialogData.button_link &&
        this.dialogData.button_link.search("ticket") > -1 &&
        this.dialogData.syndicateId
      ) {
        this.openTicketPage(this.dialogData.syndicateId);
      } else if (this.dialogData.button_link && this.dialogData.button_link.search("game") > -1) {
        this.openGamePage();
      } else if (this.dialogData.paid_button_link && this.dialogData.paid_button_link.search("syndicate") > -1) {
        this.openSyndicatePage();
      } else if (this.dialogData.button_link && this.dialogData.button_link.search("syndicate") > -1) {
        this.openSyndicatePage();
      }
    } else {
      this.openSyndicatePage();
    }
  }
  async makePayment(offer: any) {
    const openPaymentModal = await this.modalController.create({
      component: StorePaymentComponent,
      componentProps: {
        data: this.formPaymentData(offer),
      },
    });

    if (openPaymentModal) {
      openPaymentModal.onDidDismiss().then((res) => {
        if (res.data && res.data.syndicateId) {
          this.paymentService
            .getSyndicateInfoWithProducts(res.data.syndicateId)
            .pipe(
              map((detail: any) => {
                const syndicateInfo = detail[0]?.data();
                syndicateInfo.product = [];
                const productDocs = detail[1].docs;
                for (let index = 0; index < productDocs.length; index++) {
                  syndicateInfo?.product.push(productDocs[index]?.data());
                }
                return syndicateInfo;
              })
            )
            .subscribe(
              (syndicateInfo) => {
                this.showTicket(syndicateInfo);
              },
              (err) => {
                return err;
              }
            );
        }
      })
        .catch((error) => {
          return error;
        });
    }

    return await openPaymentModal.present();
  }
  private async openTicketPage(syndicateId) {
    const syndicateTickets = await this.modalController.create({
      component: SyndicateTicketsComponent,
      componentProps: { syndicate: { syndicate_id: syndicateId, syndicate_name: "", syndicate_type: "" } },
      cssClass: "modal-fullScreen",
      // enterAnimation: CustomAnimation.enterFromRight,
      //  leaveAnimation: CustomAnimation.exitThroughRight,
    });
    return await syndicateTickets.present();
  }

  formPaymentData(offer: any) {
    return {
      prize: offer?.price,
      draw: "",
      game: offer.product_name,
      offers: {
        offerid: offer.product_id,
        description: offer.product_description,
        price: offer?.price,
      },
      real_name: offer.product_name,
      isCreatingPS: false,
      voucher_code_id: offer.voucher_code_id,
      page: "voucher",
    };
  }
  private async showTicket(syndicateInfo) {
    const syndicateTickets = await this.modalController.create({
      component: SyndicateTicketsComponent,
      componentProps: { syndicate: syndicateInfo },
      cssClass: "modal-fullScreen",
    });
    return await syndicateTickets.present();
  }
  openStorePage() {
    this.router.navigateByUrl("mainTabs/tabs/store");
  }
  openSyndicatePage() {
    this.voucherService.setSyndicatePending().pipe(take(1)).subscribe({
      next: () => this.router.navigateByUrl('mainTabs/tabs/syndicate'),
      error: err => {/* handle */}
    });
  }
  openGamePage() {
    this.router.navigateByUrl("mainTabs/tabs/game");
  }

  navigateToStore() {
    this.router.navigateByUrl("mainTabs/tabs/store");
  }
}
